import React, { Fragment, Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { cloneDeep } from "lodash";
import { NumberInput, Toastr, Tooltip } from "../../revvComponents";

import {
  executeCommand,
  updateDocumentComponentAction,
  updateDocMetaAction,
  updateComponentMeta,
} from "../../actions/DocumentActions";
import {
  setSidePaneDataForPageNo,
  updateSidePaneUIAction,
} from "../../actions/QuotationActions/QuotationActions";
import EditorActions from "../../actions/EditorActions";

import { updateTemplateMetaAction } from "../../actions/DocumentTemplateActions/templateActions";

import UpdatePageNumberConfigCommand from "../../commands/updatePageNumberConfigCommand";

// Destructuring
const { nukeActiveEditor } = EditorActions;

class PageNumberListPane extends Component {
  constructor(props) {
    super(props);

    let pageStart = 1;
    let pageEnd = 1000;
    if (props.metaData) {
      if (props.metaData.pageStart && !Number.isNaN(props.metaData.pageStart)) {
        pageStart = props.metaData.pageStart;
      }

      if (props.metaData.pageStart && !Number.isNaN(props.metaData.pageEnd)) {
        pageEnd = props.metaData.pageEnd;
      }
    }

    this.state = {
      pageStart,
      pageEnd,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.updateSidePaneUI !== this.props.updateSidePaneUI) {
      let { pageStart } = this.state;
      let { pageEnd } = this.state;
      const { metaData } = this.props;
      if (metaData) {
        if (metaData.pageStart && !Number.isNaN(metaData.pageStart)) {
          pageStart = metaData.pageStart;
        }

        if (metaData.pageStart && !Number.isNaN(metaData.pageEnd)) {
          pageEnd = metaData.pageEnd;
        }
        this.setState({ pageStart, pageEnd });
      }
    }
  }

  _handleValue = (e, name) => {
    if (name === "start") {
      if (this.props.totalNumberOfPages && this.props.totalNumberOfPages < e) {
        Toastr.showToastr({
          type: "warning",
          message:
            "Start count cannot be more than the total number of pages in the document.",
          timeout: 3000,
        });
      } else if (e !== "" && e < 1) {
        Toastr.showToastr({
          type: "warning",
          message: "Start count cannot be less than 1.",
          timeout: 3000,
        });
      } else {
        this.setState({
          pageStart: e,
        });
      }
    } else if (name === "end") {
      this.setState({
        pageEnd: e,
      });
    }
  };

  _handleSave = () => {
    if (this.state.pageStart === "" || Number.isNaN(this.state.pageStart)) {
      this.state.pageStart = 1;
    }
    if (this.state.pageStart > this.state.pageEnd) {
      Toastr.showToastr({
        type: "warning",
        message: "Page start cannot be greater than page end.",
        timeout: 3000,
      });
      return;
    }

    const { metaData, mode } = this.props;
    const oldMetaData = cloneDeep(metaData);

    const updatePageNumber = new UpdatePageNumberConfigCommand({
      mode,
      pageStart: this.state.pageStart,
      pageEnd: this.state.pageEnd,
      oldMetaData,
      updateTemplateMetaAction: this.props.updateTemplateMetaAction,
      updateDocMetaAction: this.props.updateDocMetaAction,
      docID: this.props.docID,
    });
    this.props.executeCommand(updatePageNumber);
  };

  _stopClickEventPropagation = event => {
    event.nativeEvent.stopImmediatePropagation();
  };

  _hideEditPane = () => {
    this.props.updateComponentMeta({}, true);
    this.props.nukeActiveEditor();
    this.props.hideEditPane();
  };

  render() {
    const { metaData } = this.props;
    if (!metaData) {
      return null;
    }

    const toolTipText = `Page number “1” will show up on page ${this.state.pageStart} in downloaded PDF and page preview.`;
    return (
      <Fragment>
        <div
          className="components-wrapper animated fadeinright"
          onClick={this._stopClickEventPropagation}
          onKeyPress={() => {}}
          role="button"
          tabIndex="0">
          <div className="notes-header cover-page">
            <div
              className="right-pane-title"
              role="button"
              tabIndex={0}
              onClick={this._hideEditPane}
              onKeyDown={() => {}}>
              <div>Page number settings</div>
              <div className="pane-close-icon">
                <i>
                  <FontAwesomeIcon icon={["far", "times"]} />
                </i>
              </div>
            </div>
          </div>

          <div className="notes-container">
            <div className="page-number-content-scroll">
              <span className="addproduct-info margin-bottom">
                <div className="pane-text">
                  Page number will show up on the page instead of ‘#’ in
                  downloaded PDF and page preview.
                </div>
              </span>

              <table>
                <tbody>
                  <tr className="page-number-table-row">
                    <td>Start count from page</td>

                    <td>
                      {this.state.pageStart ? (
                        <Tooltip
                          placement="bottom"
                          overlay={<div>{toolTipText}</div>}>
                          <NumberInput
                            className="page-number-input"
                            data-test="page-number-start-input"
                            type="number"
                            limitTo={999}
                            value={this.state.pageStart}
                            onChange={e => this._handleValue(e, "start")}
                            onBlur={this._handleSave}
                            required
                            autoFocus
                            disabled={!this.props.isEditable}
                          />
                        </Tooltip>
                      ) : (
                        <NumberInput
                          className="page-number-input"
                          data-test="page-number-start-input"
                          type="number"
                          limitTo={999}
                          value={this.state.pageStart}
                          onChange={e => this._handleValue(e, "start")}
                          onBlur={this._handleSave}
                          required
                          autoFocus
                        />
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { updateSidePaneUI, sectionDataForPageNumber } = state.ToolPaneStore;
  const {
    document: { meta_data: docMetaData, stage: docState } = {},
    totalNumberOfPages,
  } = state.DocumentStore;
  const {
    template: { meta_data: tempMetaData, status: templateStatus },
  } = state.TemplateStore;
  let metaData;

  let isEditable = true;
  if (ownProps.mode === "DOCUMENT") {
    metaData = docMetaData;
    isEditable = docState === "DRAFT";
  }
  if (ownProps.mode === "TEMPLATE") {
    metaData = tempMetaData;
    isEditable = templateStatus === "DRAFT";
  }

  if (sectionDataForPageNumber && sectionDataForPageNumber.lock) {
    isEditable = false;
  }

  if (ownProps.isDocumentLocked) {
    isEditable = false;
  }

  return {
    updateSidePaneUI,
    metaData,
    totalNumberOfPages,
    isEditable,
  };
};

const mapDispatchToProps = {
  executeCommand,
  updateDocumentComponentAction,
  setSidePaneDataForPageNo,
  updateSidePaneUIAction,
  updateTemplateMetaAction,
  updateDocMetaAction,
  updateComponentMeta,
  nukeActiveEditor,
};

export default connect(mapStateToProps, mapDispatchToProps)(PageNumberListPane);

// export default PageNumberListPane;
